package fr.frux.core.ads

import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.width
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.outlined.OndemandVideo
import androidx.compose.material3.ButtonDefaults
import androidx.compose.material3.Icon
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.runtime.collectAsState
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import fr.frux.core.ads.resources.Res
import fr.frux.core.ads.resources.ads_rewarded_granted
import fr.frux.core.ads.resources.ads_rewarded_loading
import fr.frux.core.ads.resources.ads_rewarded_offer_link
import fr.frux.core.ads.resources.ads_rewarded_pending
import fr.frux.core.ads.resources.ads_rewarded_unavailable
import fr.frux.core.ads.resources.ads_rewarded_validating
import org.jetbrains.compose.resources.stringResource

/**
 * Texte de la snackbar après une vidéo récompensée (#531), commun au Profil et à la carte.
 * `null` : rien à dire (vidéo fermée avant la fin, ou aucun résultat en attente).
 */
@Composable
fun rewardedResultMessage(result: RewardedResult?): String? =
    when (result) {
        RewardedResult.GRANTED -> stringResource(Res.string.ads_rewarded_granted)
        RewardedResult.PENDING -> stringResource(Res.string.ads_rewarded_pending)
        RewardedResult.UNAVAILABLE -> stringResource(Res.string.ads_rewarded_unavailable)
        RewardedResult.DISMISSED, null -> null
    }

/**
 * Lien discret « Regarder une vidéo pour 24 h sans pub » sous la bannière de carte et l'annonce native (#531).
 * N'occupe aucune place tant que la vidéo n'est pas proposable ([AdsController.canOfferRewarded]). Reste en
 * place, désactivé, pendant que la vidéo [loading] charge, pour qu'un second appui ne tombe pas à côté,
 * et pendant l'attente de validation de la récompense ([AdsController.rewardedPending]).
 */
@Composable
internal fun RewardedOfferLink(
    onClick: () -> Unit,
    loading: Boolean,
    modifier: Modifier = Modifier,
) {
    val offered by LocalAdsController.current.canOfferRewarded.collectAsState()
    val validating by LocalAdsController.current.rewardedPending.collectAsState()
    if (!offered && !loading && !validating) return
    TextButton(
        onClick = onClick,
        enabled = !loading && !validating,
        contentPadding = ButtonDefaults.TextButtonWithIconContentPadding,
        modifier = modifier,
    ) {
        // Annonce la vidéo avant même la lecture du libellé : sans elle, l'appui surprenait.
        Icon(Icons.Outlined.OndemandVideo, contentDescription = null, modifier = Modifier.size(18.dp))
        Spacer(Modifier.width(8.dp))
        Text(
            text =
                stringResource(
                    when {
                        loading -> Res.string.ads_rewarded_loading
                        validating -> Res.string.ads_rewarded_validating
                        else -> Res.string.ads_rewarded_offer_link
                    },
                ),
            style = MaterialTheme.typography.labelLarge,
        )
    }
}
